import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import ChatWidget from "@/components/ChatWidget";
import VisitorPing from "@/components/VisitorPing";
import PageTitle from "@/components/PageTitle";

export default function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-cream">
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
      <ChatWidget />
      <VisitorPing />
      <PageTitle />
    </div>
  );
}
